import { DateTimeOffset } from 'components/Form/BDatePicker';
import { SupportedHourlyRentalTypes } from 'enums/supportedRentalTypes';
import { FormAction } from 'hooks/useForm';
import { Dispatch, useEffect, useMemo } from 'react';
import { dateService } from 'services/DateService';
import { VehicleBasedDemandState } from 'types/demand.type';
import { HourlyRentalInfo } from 'types/vehicle.type';
import { usePriceWidgetHourGenerator } from './usePriceWidgetHourGenerator';

export function usePriceWidgetSwimmingTour(
  state: VehicleBasedDemandState,
  dispatch: Dispatch<FormAction<VehicleBasedDemandState>>,
  rentalInfo: HourlyRentalInfo
) {
  const dayjs = dateService.getDayjs();

  const doesVehicleSupportOnlySwimmingTour = useMemo(() => {
    return rentalInfo.supportedRentalTypes.every(
      (rentalTypes) => rentalTypes === SupportedHourlyRentalTypes.SWIMMING_TOUR
    );
  }, [rentalInfo.supportedRentalTypes]);

  const doesVehicleNotSupportSwimmingTour = useMemo(() => {
    return rentalInfo.supportedRentalTypes.every(
      (rentalTypes) => rentalTypes !== SupportedHourlyRentalTypes.SWIMMING_TOUR
    );
  }, [rentalInfo.supportedRentalTypes]);

  const { generateHourArrayWithoutTen } = usePriceWidgetHourGenerator();

  const disabledHoursWhenSwimmingTourSelected = useMemo<
    DateTimeOffset[]
  >(() => {
    return generateHourArrayWithoutTen().map((hour) => ({
      hour,
    }));
  }, []);

  useEffect(() => {
    if (state.isSwimmingTour) {
      const newDate = dayjs(state.date).hour(10).toDate();
      const newDuration = 8;

      dispatch({
        type: 'REPLACE_STATE',
        payload: {
          ...state,
          date: newDate,
          duration: newDuration,
        },
      });
    }
  }, [state.isSwimmingTour]);

  useEffect(() => {
    if (doesVehicleSupportOnlySwimmingTour) {
      dispatch({
        type: 'isSwimmingTour',
        payload: true,
      });
    }
  }, []);

  return {
    doesVehicleSupportOnlySwimmingTour,
    doesVehicleNotSupportSwimmingTour,
    disabledHoursWhenSwimmingTourSelected,
  };
}
